module.exports = {"350425100":"均溪镇","350425101":"石牌镇","350425102":"上京镇","350425103":"广平镇","350425104":"桃源镇","350425105":"太华镇","350425106":"建设镇","350425107":"奇韬镇","350425200":"华兴乡","350425201":"屏山乡","350425202":"吴山乡","350425203":"济阳乡","350425204":"武陵乡","350425205":"谢洋乡","350425206":"文江乡","350425207":"梅山乡","350425208":"湖美乡","350425209":"前坪乡","350425400":"东风农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350425.json
// module id = 1094
// module chunks = 0